export const firBoundariesListArray = [
  {
    id: 1,
    firName: 'FIR',
    latitude: 22.5,
    longitude: 98.555555,
    sequence: 33,
    country: 'Mexico',
  },
];
